<template>
  <v-dialog v-model="dialog" max-width="40%">
    <template #activator="{ on }">
      <div v-if="minimal">
        <v-btn v-on="on" v-if="batch.archived" icon small>
          <v-icon small color="primary">mdi-power-sleep</v-icon>
        </v-btn>
        <v-btn v-else v-on="on" icon small>
          <v-icon small color="primary">mdi-run</v-icon>
        </v-btn>
      </div>
      <div v-else>
        <v-btn v-on="on" v-if="batch.archived" color="primary" dark outlined rounded>
          <v-icon left>mdi-power-sleep</v-icon>
          Archived
        </v-btn>
        <v-btn v-else color="primary" v-on="on" dark outlined rounded>
          <v-icon left>mdi-run</v-icon>
          Active
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title v-if="batch.archived">
        Activate Batch
        <v-spacer/>
        <v-btn icon><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-title v-else>
        Archive Batch
        <v-spacer/>
        <v-btn icon><v-icon>exit</v-icon></v-btn>
      </v-card-title>
      <v-card-subtitle v-if="batch.archived">
        Activating a batch will allow it to be processed, shipped, or QC'd.  You can always archive it again.
      </v-card-subtitle>
      <v-card-subtitle v-else>
        Archiving a batch will remove it from processing, shipping, or QC options.  You should archive a batch if you
        no longer plan to use it in any future projects.  You can always un-archive if you need it later.
      </v-card-subtitle>
      <v-card-text v-if="batch.archived" class="body-1 primary--text font-weight-medium">
        Activate {{ batch.forgeID }} - {{ batch.name }}
      </v-card-text>
      <v-card-text v-else class="body-1 primary--text font-weight-medium">
        Archive {{ batch.forgeID }} - {{ batch.name }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn text @click="changeState" :loading="loading" color="green">
          <v-icon left>save</v-icon>
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Batch from "../../models/Batch";
export default {
  name: "BatchStateChange",
  props: {
    minimal: {
      type: Boolean,
      required: true,
      default: false
    },
    batch: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialog: false
    }
  },
  methods: {
    changeState() {
      this.loading = true;
      Batch
        .$put(this.batch.id, { archived: !this.batch.archived })
        .then(() => {
          this.dialog = false;
          this.loading = false;
        })
    }
  }
}
</script>
